import * as i0 from '@angular/core';
import { ElementRef, ViewChild, Input, Component, Directive, NgModule } from '@angular/core';
import { startWith, filter, Subject, firstValueFrom, takeUntil, BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@azavista/components/shared';
import { pick, AzavistaSharedModule } from '@azavista/components/shared';
import * as i1$1 from '@angular/material/tabs';
const _c0 = ["exportedTemplateRef"];
const _c1 = ["exportedElementRef"];
const _c2 = ["*"];
function AzavistaExportedElementWrapperComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "apply");
    i0.ɵɵelementContainer(3, 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const exportedTemplateRef_r2 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 2, (tmp_3_0 = ctx_r0.loadedElementRefType) !== null && tmp_3_0 !== undefined ? tmp_3_0 : "inline", ctx_r0.onLoadRef), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", exportedTemplateRef_r2);
  }
}
function AzavistaExportedElementWrapperComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", null, 2);
    i0.ɵɵelementContainer(3, 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const ngContent_r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate2("", ctx_r0.className, " ", ctx_r0.className + "--" + ctx_r0.loadedElementRefType, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ngContent_r3);
  }
}
function AzavistaExportedElementWrapperComponent_ng_template_3_ng_content_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngIf", "isViewInit && loadedElementRefType"]);
  }
}
function AzavistaExportedElementWrapperComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AzavistaExportedElementWrapperComponent_ng_template_3_ng_content_0_Template, 1, 0, "ng-content", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.isViewInit && ctx_r0.loadedElementRefType);
  }
}
const EXPORTED_ELEMENT_WRAPPER_CLASS_NAME = 'aza-exported-element-wrapper';
const EXPORTED_ELEMENT_CONSUMER_CLASS_NAME = 'aza-exported-element-consumer';
let AzavistaExportedElementWrapperComponent = /*#__PURE__*/(() => {
  class AzavistaExportedElementWrapperComponent {
    get templateRef() {
      this.onLoadRef('templateRef');
      return this._templateRef;
    }
    set elementRef(value) {
      if (value) {
        this._elementRef = value;
        this._elementRefLoaded$.next(value);
      }
    }
    get elementRef() {
      this.onLoadRef('elementRef');
      return this._elementRef;
    }
    get elementRefLoaded$() {
      return this._elementRefLoaded$.pipe(startWith(this._elementRef), filter(value => !!value?.nativeElement));
    }
    constructor(ngZone) {
      this.ngZone = ngZone;
      this.loadedElementRefType = null;
      this._elementRefLoaded$ = new Subject();
      this.isViewInit = false;
      this.className = EXPORTED_ELEMENT_WRAPPER_CLASS_NAME;
      this.onLoadRef = refType => {
        this.loadedElementRefType = refType;
        this.isViewInit = true;
      };
    }
    async ngAfterViewInit() {
      await firstValueFrom(this.ngZone.onStable);
      this.isViewInit = true;
    }
    static {
      this.ɵfac = function AzavistaExportedElementWrapperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaExportedElementWrapperComponent)(i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaExportedElementWrapperComponent,
        selectors: [["azavista-exported-element-wrapper"]],
        viewQuery: function AzavistaExportedElementWrapperComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._templateRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.elementRef = _t.first);
          }
        },
        inputs: {
          loadedElementRefType: "loadedElementRefType"
        },
        standalone: false,
        ngContentSelectors: _c2,
        decls: 5,
        vars: 1,
        consts: [["exportedTemplateRef", ""], ["ngContent", ""], ["exportedElementRef", ""], [4, "ngIf"], [3, "ngTemplateOutlet"]],
        template: function AzavistaExportedElementWrapperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, AzavistaExportedElementWrapperComponent_ng_container_0_Template, 4, 5, "ng-container", 3)(1, AzavistaExportedElementWrapperComponent_ng_template_1_Template, 4, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, AzavistaExportedElementWrapperComponent_ng_template_3_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.isViewInit && ctx.loadedElementRefType !== "templateRef");
          }
        },
        dependencies: [i1.NgIf, i1.NgTemplateOutlet, i2.ApplyFunctionPipe],
        encapsulation: 2
      });
    }
  }
  return AzavistaExportedElementWrapperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const STOP_PROPAGATION_KEYBOARD_KEYS = ['ArrowLeft', 'ArrowDown', 'ArrowUp', 'ArrowRight'];
const STOP_PROPAGATION_KEYBOARD_TAG_NAMES = ['INPUT', 'TEXTAREA'];
/**
 * Usage:
 ```
 <mat-tab-group matTabGroupUseExportedElement>
    <mat-tab
        [azavistaExportedElementInput]="dashboardElement?.exportedElement"
    >
        <azavista-dashboard #dashboardElement></azavista-dashboard>
    </mat-tab>
    <mat-tab [azavistaExportedElementInput]="wrapperElement">
        <azavista-exported-element-wrapper
            #wrapperElement
        ></azavista-exported-element-wrapper>
    </mat-tab>
    <mat-tab [azavistaExportedElementInput]="teamTable?.exportedElement">
        <azavista-table #teamTable></azavista-table>
    </mat-tab>
</mat-tab-group>
```
 */
let AzavistaMatTabGroupUseExportedElementDirective = /*#__PURE__*/(() => {
  class AzavistaMatTabGroupUseExportedElementDirective {
    constructor(element, host, ngZone) {
      this.element = element;
      this.host = host;
      this.ngZone = ngZone;
      this.onDestroy$ = new Subject();
    }
    ngAfterViewInit() {
      this.initiateAllTabsExportedElement();
      const tabHeader = this.getElementAsExportedElementContainer();
      if (!tabHeader) {
        return;
      }
      this.createExportedElementContainer(tabHeader);
      this.host.selectedTabChange.pipe(startWith({
        tab: this.host._allTabs.toArray()[this.host.selectedIndex ?? 0]
      }), takeUntil(this.onDestroy$)).subscribe(async change => {
        const selectedTab = change.tab;
        await this.loadExportedElementFromTab(selectedTab);
      });
    }
    ngOnDestroy() {
      this.onDestroy$.next();
      this.onDestroy$.complete();
    }
    async loadExportedElementFromTab(selectedTab) {
      const selectedTabExporter = selectedTab;
      if (!selectedTabExporter.exportedElement) {
        await firstValueFrom(this.ngZone.onStable);
      }
      this.loadExportedElement(selectedTabExporter?.exportedElement);
      selectedTabExporter?.exportedElementChanges$?.pipe(takeUntil(this.host.selectedIndexChange), takeUntil(this.onDestroy$)).subscribe(value => {
        if (value) {
          this.loadExportedElement(value);
        }
      });
    }
    async loadExportedElement(exportedElement) {
      exportedElement?.onLoadRef('elementRef');
      if (this.exportedElementContainer) {
        this.exportedElementContainer.innerHTML = '';
        if (exportedElement) {
          const exportedElementElementRef = await firstValueFrom(exportedElement?.elementRefLoaded$);
          if (exportedElementElementRef) {
            this.exportedElementContainer.appendChild(exportedElementElementRef.nativeElement);
          }
        }
      }
    }
    createExportedElementContainer(tabHeaderRef) {
      this.exportedElementContainer = document.createElement('div');
      this.exportedElementContainer.className = EXPORTED_ELEMENT_CONSUMER_CLASS_NAME;
      this.exportedElementContainer.addEventListener('keydown', event => {
        if (STOP_PROPAGATION_KEYBOARD_TAG_NAMES.includes(event.target?.tagName) || STOP_PROPAGATION_KEYBOARD_KEYS.includes(event.code)) {
          event.stopImmediatePropagation();
        }
      });
      tabHeaderRef.appendChild(this.exportedElementContainer);
    }
    getElementAsExportedElementContainer() {
      return this.element.nativeElement.querySelector('mat-tab-header .mat-mdc-tab-labels');
    }
    async initiateAllTabsExportedElement() {
      await firstValueFrom(this.ngZone.onStable);
      this.host._allTabs.forEach(tab => {
        const selectedTabExporter = tab;
        selectedTabExporter.exportedElement?.onLoadRef('elementRef');
      });
    }
    static {
      this.ɵfac = function AzavistaMatTabGroupUseExportedElementDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaMatTabGroupUseExportedElementDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$1.MatTabGroup), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AzavistaMatTabGroupUseExportedElementDirective,
        selectors: [["mat-tab-group", "azavistaMatTabGroupUseExportedElement", ""]],
        standalone: false
      });
    }
  }
  return AzavistaMatTabGroupUseExportedElementDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaExportedElementBase = /*#__PURE__*/(() => {
  class AzavistaExportedElementBase {
    constructor() {
      this.exportedElementChanges$ = new BehaviorSubject(null);
    }
    get exportedElement() {
      return this.getExportedElement();
    }
    set exportedElement(value) {
      this.setExportedElement(value);
    }
    getExportedElement() {
      return this._exportedElement ?? null;
    }
    setExportedElement(value) {
      this._exportedElement = value;
      if (value) {
        this.exportedElementChanges$.next(value);
      }
    }
    static {
      this.ɵfac = function AzavistaExportedElementBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaExportedElementBase)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AzavistaExportedElementBase
      });
    }
  }
  return AzavistaExportedElementBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaExportedElementExporterDirective = /*#__PURE__*/(() => {
  class AzavistaExportedElementExporterDirective extends AzavistaExportedElementBase {
    get exportedElement() {
      return this.getExportedElement();
    }
    set exportedElement(value) {
      this.setExportedElement(value);
    }
    constructor(ngZone) {
      super();
      this.ngZone = ngZone;
    }
    async setExportedElement(value) {
      if (value) {
        await firstValueFrom(this.ngZone.onStable);
        super.setExportedElement(value);
      }
    }
    static {
      this.ɵfac = function AzavistaExportedElementExporterDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaExportedElementExporterDirective)(i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AzavistaExportedElementExporterDirective,
        selectors: [["", "azavistaExportedElementExporter", ""]],
        viewQuery: function AzavistaExportedElementExporterDirective_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(AzavistaExportedElementWrapperComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.exportedElement = _t.first);
          }
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return AzavistaExportedElementExporterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaExportedElementInputDirective = /*#__PURE__*/(() => {
  class AzavistaExportedElementInputDirective extends AzavistaExportedElementBase {
    get exportedElement() {
      return this.getExportedElement();
    }
    /**
     * @important Please use null coalescing operator (` ?? null`) to prevent `ExpressionChangedAfterItHasBeenCheckedError` if necessary
     *
     * @example
     *  ```
     * <some-element [azavistaExportedElementInput]="theInput?.exportedElement ?? null">
     * ```
     */
    set exportedElement(value) {
      this.setExportedElement(value);
    }
    constructor(element, host) {
      super();
      this.element = element;
      this.host = host;
    }
    setExportedElement(value) {
      super.setExportedElement(value);
      Object.assign(this.host, pick(this, ['exportedElementChanges$', 'exportedElement']));
    }
    static {
      this.ɵfac = function AzavistaExportedElementInputDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaExportedElementInputDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$1.MatTab));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AzavistaExportedElementInputDirective,
        selectors: [["", "azavistaExportedElementInput", ""]],
        inputs: {
          exportedElement: [0, "azavistaExportedElementInput", "exportedElement"]
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return AzavistaExportedElementInputDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaExportedElementModule = /*#__PURE__*/(() => {
  class AzavistaExportedElementModule {
    static {
      this.ɵfac = function AzavistaExportedElementModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaExportedElementModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaExportedElementModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, AzavistaSharedModule]
      });
    }
  }
  return AzavistaExportedElementModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaExportedElementExporterDirective, AzavistaExportedElementInputDirective, AzavistaExportedElementModule, AzavistaExportedElementWrapperComponent, AzavistaMatTabGroupUseExportedElementDirective, EXPORTED_ELEMENT_CONSUMER_CLASS_NAME, EXPORTED_ELEMENT_WRAPPER_CLASS_NAME };
